// Sticky toolbar shown above the editor.
//
// Left side: the Add-field popover trigger — opens a list of variables
// the user can drop into the editor at the current caret position.
// Right side: a kebab (⋯) button opening the "View" menu — switches
// how the editor renders `{TOKEN}` literals (Preview = chips vs.
// Source = plain text).
//
// The toolbar is stateless — `mode` and the callbacks come from the
// parent `TextareaWithVariables` class component.

import React from 'react'

import AddField from "../../gd-modules/common/add-column-new/add-field"
import PopupMenuButton from "../popover-menu/popup-menu-button/popup-menu-button"
import ControlButtonStandard, {ControlButtonType} from "../buttons/control-button/control-button-standard"
import TextareaWithVariablesViewModeMenu from "./textarea-with-variables-view-mode-menu"
import {ViewMode} from './types'
import {AddFieldConfig} from './add-field/build-config'
import {ControlButtonSize} from "../buttons/control-button/@types"

type Props = {
    config        : AddFieldConfig
    mode          : ViewMode
    onInsertToken : (rawToken: string) => void
    onSetMode     : (mode: ViewMode) => void
    iconOnly?     : boolean   // renders both buttons as bare icons (no "Add field" label) — used by the single-line hover overlay
}

export default function TextareaWithVariablesToolbar(props: Props) {

    const {config, mode, onInsertToken, onSetMode, iconOnly} = props

    const btnComponent = (state: any, props: any) => {
        const classes = Classes({
            'show-popover': state.showPopover
        })
        return (
            <ControlButtonStandard
                className   = {classes}
                size        = {ControlButtonSize.SIZE_26}
                type        = {ControlButtonType.MORE}
            />
        )
    }

    const addFieldTrigger = iconOnly
        ? (
            <ControlButtonStandard
                size      = {ControlButtonSize.SIZE_26}
                iconClass = "i5-formula"
                hint      = "Add field"
            />
        )
        : (
            <div className="ui5-control-button-with-label s-26 active">
                <div className="ico i5-formula"/>
                <div className="btn-label">Add field</div>
            </div>
        )

    const addFieldButton = (
        <AddField manageColumnsConfig = {config.manageColumnsConfig}
                  fields              = {config.fields}
                  showAdd             = {false}
                  onToggleColumn      = {onInsertToken}>
            {addFieldTrigger}
        </AddField>
    )

    const viewModeButton = (
        <PopupMenuButton
            hint             = "View"
            attachment       = "top right"
            targetAttachment = "bottom right"
            offset           = "0 -6"
            btnComponent     = {btnComponent}
            menuComponent    = {TextareaWithVariablesViewModeMenu}
            menuParams       = {{mode, onSetMode}}
        />
    )

    if (iconOnly) {
        return (
            <div className="ui5-editor-template__toolbar--overlay flex-row-left-center">
                {addFieldButton}
                {viewModeButton}
            </div>
        )
    }

    return (
        <div className="ui5-editor-template__toolbar p-t-4 p-b-4 p-l-4 p-r-4">
            <div className="flex-row-left-center">{addFieldButton}</div>
            <div className="flex-row-left-center">{viewModeButton}</div>
        </div>
    )
}
